export default __webpack_public_path__ + "static/media/mobisol.16b03a7d.PNG";